class BuildTags {
}
/** Hash the last time inertia was built */
BuildTags.buildHash = '9dbd23cc';
/** Version of the package.json file the last time inertia was built */
BuildTags.packageVersion = '1208.0.2';
/** Time inertia was built in UTC */
BuildTags.buildTime = 'Wed, 04 Nov 2026 17:04:00 GMT';
/** Time inertia was built in Boston time */
BuildTags.buildTimeBoston = '2026-11-04 12:03:40 Boston';
/** Detailed build tags string */
BuildTags.detailed = 'BuildTags: 2026-11-04 12:03:40 Boston - 9dbd23cc - 1208.0.2';
export default BuildTags;
